<template>
  <div id="app">
    <div>
      <app-loader v-if="loading"/>
    </div>
    <router-view/>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "App",
  computed: {
    ...mapState(['loading']),
  }
};
</script>

<style>
#app {
  font-family: 'Roboto', "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue